import Loadable from '../../../../components/loadable';

export default Loadable(() =>
  import(
    /* webpackChunkName: "consumer-technologies-live-3d-face-ar" */ './index'
  )
);
